import * as React from 'react';

import { Box, Typography, Stack, useTheme, Button } from '@mui/material';
import { useAuth } from '@dwelvio/auth-react';

import { useNavigate, useSearchParams } from 'react-router';
import { ForgotForm } from './components/forgot-form';

import { IUserData } from '../../types';
import { LogoWithText } from '../../components/logo-with-text';

import { useAlert } from '@dwelvio/react-alert';
import { appPaths } from '../../app-paths';

export function PasswordForgotPage() {
  const { forgotPassword } = useAuth<IUserData>();
  const [params, setParams] = useSearchParams();
  const theme = useTheme();
  const { show } = useAlert();
  const navigate = useNavigate();

  const accountId = params.get('a') || undefined;
  const success = params.get('success');

  return (
    <Box
      maxWidth="400px"
      minWidth="300px"
      sx={{ mx: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
    >
      <Box
        component="header"
        sx={{ mx: 'auto', py: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <LogoWithText color={theme.palette.primary.main} textColor={theme.palette.secondary.dark} height={50} />
      </Box>
      <Box component="main" sx={{ mx: 'auto', py: 3, px: 2 }}>
        <Stack gap={1} sx={{ mt: 2 }}>
          {!success && (
            <ForgotForm
              onSubmit={(username: string) => {
                forgotPassword({ username, accountId })
                  .then(() => {
                    setParams((prev) => {
                      const newParams = new URLSearchParams();
                      newParams.set('success', '1');
                      return newParams;
                    });
                  })
                  .catch((error) => {
                    setParams((prev) => {
                      const newParams = new URLSearchParams(prev);
                      newParams.set('success', '0');
                      newParams.set('result', error.message || 'Unknown error');
                      return newParams;
                    });
                    show.error(error.message || 'Unknown error');
                  });
              }}
            />
          )}
          {success === '1' && (
            <>
              <Typography variant="body1" textAlign="center">
                Ak email, ktorý ste zadali v systéme existuje, tak naň dostanete v priebehu 10 minút odkaz na obnovenie
                hesla.
              </Typography>
              <Typography variant="body1" textAlign="center">
                Ak email nedostanete, skontrolujte prosím zložku so spamom alebo kontaktujte podporu.
              </Typography>
              <Button variant="outlined" color="primary" onClick={() => navigate(appPaths.signin.navigate())}>
                Prejsť na prihlásenie
              </Button>
            </>
          )}
          {success === '0' && (
            <>
              <Typography variant="body1" textAlign="center">
                Nastala chyba pri obnovení hesla. Skúste to prosím neskôr.
              </Typography>
              <Typography variant="body2" textAlign="center" color="error">
                Chyba: {params.get('result') ?? ''}
              </Typography>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  setParams((prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.delete('success');
                    newParams.delete('result');
                    return newParams;
                  });
                }}
              >
                Späť
              </Button>
            </>
          )}
        </Stack>
      </Box>
      <Box component="footer" sx={{ py: 3 }}>
        <Typography variant="body2" textAlign="center">
          © dwelvio.com {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
  );
}
